<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/iqc/inspection/bill/page" getKey="rows" :columns="columns">
      <template #conditions> </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('jianyandanmingxi', scope.row, '80%')">{{ $t('mingxi') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'jianyandanmingxi'">
        <div class="dialog-scroller">
          <iqc-inspection-detail :iqcInspectionId="yt.editObj.id" :iqcInspectionNo="yt.editObj.no"></iqc-inspection-detail>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" @click="yt.isShowEditDialog = false">{{ $t('baocun') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import iqcInspectionDetail from './iqc_inspection_detail.vue';

export default {
  name: 'web_cast_management_soup_record_iqc_inspection',
  components: {
    iqcInspectionDetail
  },
  props: {
    soupRecordId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      conditions: {
        sourceDocumentId: this.soupRecordId,
        iqcSourceType: '30'
      },
      columns: [
        {
          label: 'iqcdanhao',
          prop: 'no'
        },
        {
          label: 'danjuzhuangtai',
          prop: 'status',
          type: 'dictionary_tag',
          key: 'IQC_ORDER_STATUS'
        },
        {
          label: 'jianyanbiaozhunmingcheng',
          prop: 'inspectionStandard.name'
        },
        {
          label: 'jianyanjieguo',
          prop: 'inspectionResult',
          type: 'dictionary',
          key: 'TEST_RESULTS'
        },
        {
          label: 'wuliaobianma',
          prop: 'material.code',
          width: 150
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name',
          width: 150
        },
        {
          label: 'wuliaoguige',
          prop: 'material.spec'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = this.utils.copy(this.conditions);
      this.yt.get(1);
    }, 300);
  },
  methods: {}
};
</script>
